import { trigger, state, style, transition, animate } from '@angular/animations';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { ConfirmationService, MessageService } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Table } from 'primeng/table';
import { CourseModuleCreateDto, CourseModuleDto } from 'src/app/aplication/api/Manipulate/CoursesObjects/CourseModuleDto';
import { LessonCreateDto, LessonDto } from 'src/app/aplication/api/Manipulate/CoursesObjects/LessonDto';
import { CourseModuleService } from 'src/app/aplication/api/Services/CourseServices/CourseModule.service';
import { LessonService } from 'src/app/aplication/api/Services/CourseServices/LessonService.service';
import { LessonVideoService } from 'src/app/aplication/api/Services/CourseServices/LessonVideoService.service';

@Component({
  selector: 'app-module-details',
  templateUrl: './module-details.component.html',
  styleUrl: './module-details.component.scss',
  animations: [
    trigger('slideInOut', [
      state('in', style({ transform: 'translateX(0)' })),
      state('out', style({ transform: 'translateX(-100%)' })),
      transition(':enter', [
        style({ transform: 'translateX(-100%)', opacity: 0 }),
        animate('300ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateX(-100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class ModuleDetailsComponent {
  @ViewChild('createLesson') createLesson!: OverlayPanel;

  
  //CONTROLE
  addingLesson:boolean=false;
  showDialogLessonDetails:boolean=false;
  loaded:boolean=false;
  editMode:boolean=false;
  requestingMaterials:boolean=false;
  isUploading:boolean=false;
  downloading:boolean=false;
  
  //LISTS
  listLessons:LessonDto[]=[]
  selectedFiles: File[] = [];

  //YOUTUBE
  youtubeUrl:string='';
  
  //DECLARAÇÕES
  newLesson:LessonCreateDto = new LessonCreateDto();
  editedModule:CourseModuleCreateDto = new CourseModuleCreateDto()
  selectedLesson:LessonDto = new LessonDto()

  //ANIMATIONS
  animationNotFound: AnimationOptions = {
    path: 'assets/Animations/animationNotFoundPages.json',
  };
  

  //PROPS
  private _selectedModule !: CourseModuleDto;
  public get selectedModule() : CourseModuleDto {
    return this._selectedModule;
  }
  @Input() public set selectedModule(v : CourseModuleDto) {
    this._selectedModule = v;
    if(v){
      this.GetLessons(v)
      this.editedModule = {...this.selectedModule!}
    }
  }

  @Output() altered: EventEmitter<boolean> = new EventEmitter();
  @Output() showPanel: EventEmitter<boolean> = new EventEmitter();

  constructor(
    protected _moduleService:CourseModuleService,
    protected _lessonService:LessonService,
    protected messageService:MessageService,
    protected _confirmationService:ConfirmationService,
    protected _lessonVideo:LessonVideoService,
  ){}

  GetLessons(module:CourseModuleDto){
    this._lessonService.GetLessonsByModule(module.id).subscribe(
      response=>{
        this.listLessons = response;
        this.loaded=true;
      }
    )
  }

  CancelEdit(){
    this.editMode=false;
    this.editedModule = {...this.selectedModule!}

    // this.editedModule = new CourseModuleDto()
  }

  EditModule(){
    this._moduleService.EditModule(this.editedModule, this.selectedModule.id).subscribe(
      response=>{
        this.selectedModule.order = response.order;
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Módulo Salvo',
          life: 2000
        });

        this.editMode = false;
        this.altered.emit(true)
      },error=>{
        this.editMode = false;

        this.messageService.add({
          severity: 'error',
          summary: 'Atenção',
          detail: 'Erro ao editar módulo',
          life: 2000
        });
      }
    )
  }

  AddLesson(){
    
    this.newLesson.moduleId = this.selectedModule.id; 
    this._lessonService.AddLesson(this.newLesson).subscribe(
      response=>{
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Lição Criada',
          life: 2000
        });

        this.addingLesson = false;
        this.listLessons.push(response);
        this.createLesson.hide();
      },error=>{
        this.addingLesson = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Atenção',
          detail: 'Erro ao criar lição',
          life: 2000
        });
      }
    )
  }
  
  ChangeLessonOrder(event:any){
    moveItemInArray(this.listLessons, event.previousIndex, event.currentIndex);
    this.EditLessonsOrder(event.currentIndex+1, event.item.data.id,event);
  }

  EditLessonsOrder(newOrderNumber:number, statusId:string, event:any){
    this.loaded=false;
    this._lessonService.UpdateOrderByLesson(newOrderNumber, statusId).subscribe(
      response=>{
        this.messageService.add({ severity: 'success', summary: 'Confirmado', detail: 'Ordem Alterada!', life: 3000 });
        setTimeout(() => {
          this.loaded=false;
          this.GetLessons(this.selectedModule)
        }, 100);
      },error=>{
        this.loaded=true;
        moveItemInArray(this.listLessons, event.currentIndex, event.previousIndex);
        this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao editar ordem!', life: 3000 });
      }
    )
  }

  ConfirmDeleteLesson(event:any, lesson:LessonDto){
    event.stopPropagation();

    this._confirmationService.confirm({
      target: event.target as EventTarget,
      header: 'Confirmar exclusão?',
      message: 'Excluir este curso?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this._lessonService.Delete(lesson.id!).subscribe(response => {
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Exclusão concluída',
            life: 2000
          });

          this.listLessons = this.listLessons.filter(x=>x.id !=lesson.id);
        });
      },
      reject: () => {
        this.messageService.add({
          severity: 'warn',
          summary: 'Cancelado',
          detail: 'Operação cancelada.',
          life: 2000
        });
      }
    });
  }

  onGlobalFilter(event: Event, dt: Table) {
   const input = event.target as HTMLInputElement;
    dt.filterGlobal(input.value, 'contains');
  }

  ShowDialogLessonDetails(lesson:LessonDto){
    this.showDialogLessonDetails =true;
    this.requestingMaterials=true;

    this._lessonService.GetLessonMaterials(this.selectedModule.courseId, lesson.id).subscribe(
      response=>{
        this.selectedLesson=lesson;
        this.requestingMaterials=false;
        console.log(response)
        this.selectedLesson.materials = [...response];
      }
    )
  }

  uploadVideo(event:any){
    this.selectedFiles = event.currentFiles;

    if (this.selectedFiles.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Nenhum arquivo selecionado.',
        life: 2000
      });
      return;
    }

    this.isUploading = true; // Ativa o loading
    this.messageService.add({severity: 'info', summary: 'Aguarde',detail: 'Upload iniciado...', life: 3000});

    let formData = new FormData();

    if (this.selectedFiles.length > 0) {
      formData.append('file', this.selectedFiles[0]);
    }

    this._lessonVideo.AddLessonAndTranscodeVideo(this.selectedLesson.id, formData).subscribe(
      response=>{
        this.isUploading=false;
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Upload Concluído',
          life: 2000
        });
      },error=>{
        this.isUploading=false;
        this.messageService.add({
          severity: 'error',
          summary: 'Atenção',
          detail: 'Erro ao subir vídeo',
          life: 2000
        })
      }
    )

  }

  setYoutubeVideo(overlay?:OverlayPanel){
    const url = this.youtubeUrl.trim();

    if (!url) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Informe o link do YouTube.',
        life: 2000
      });
      return;
    }

    this.isUploading = true;
    this.messageService.add({severity: 'info', summary: 'Aguarde', detail: 'Salvando link...', life: 3000});

    this._lessonVideo.SetYoutubeVideo(this.selectedLesson.id, url).subscribe(
      response=>{
        this.isUploading=false;
        this.youtubeUrl='';
        overlay?.hide();
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Vídeo do YouTube adicionado',
          life: 2000
        });
      },error=>{
        this.isUploading=false;
        this.messageService.add({
          severity: 'error',
          summary: 'Atenção',
          detail: 'Erro ao adicionar vídeo do YouTube',
          life: 2000
        });
      }
    )
  }

  uploadMaterial(event:any): void {
    this.selectedFiles = event.currentFiles;

    if (this.selectedFiles.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Nenhum arquivo selecionado.',
        life: 3000
      });
      return;
    }

    this.isUploading = true; // Ativa o loading
    this.messageService.add({severity: 'info', summary: 'Aguarde',detail: 'Upload iniciado...', life: 3000});

    let formData = new FormData();

    if (this.selectedFiles.length > 0) {
      formData.append('materialFile', this.selectedFiles[0]);
    }

    this._lessonService.PostMaterial(this.selectedModule.courseId,this.selectedLesson.id, formData).subscribe(
      response=>{
        this.isUploading=false;
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Upload Concluído',
          life: 2000
        });
      },error=>{
        this.isUploading=false;
        this.messageService.add({
          severity: 'error',
          summary: 'Atenção',
          detail: 'Erro ao subir material',
          life: 2000
        });
      }
    )
  }

  openInNewTab(url:string): void {
    window.open(url, '_blank');
  }
}
